import * as React from "react";
const InfoIcon = ({ width = 20, height = 20, props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle fill="#22c55e" cx={24} cy={24} r={21} />
    <path fill="#fff" d="M22 22h4v11h-4z" />
    <circle fill="#fff" cx={24} cy={16.5} r={2.5} />
  </svg>
);
export default InfoIcon;
